import {useMutation} from "@tanstack/react-query";
import {stripeIntentByIdUrl} from "../../constants/api/endpoints";
import {useAxios} from "../../hooks/axios/useAxios";
import {toast} from "react-toastify";

export const useMutatePaymentIntent = ({payment_intent_id} : {payment_intent_id?: string}) => {
  const axios = useAxios();

  async function postData(data: { country: string, postal_code: string }) {
    return axios.patch(stripeIntentByIdUrl(payment_intent_id), data).then(response => response?.data)
  }

  return useMutation({
    mutationKey: ['stripe-session', payment_intent_id],
    mutationFn: postData,
    retry: 1,
    onError: (error) => {
      // @ts-ignore
      if (error?.response?.data?.error) {
        // @ts-ignore
        toast.error(error?.response?.data?.error);
      }
    }
  });
}
